<template>
  <div class="login-container" v-if="isLoading">
    <!-- <iframe src="http://182.92.128.136/" frameborder="0" width="100%" height="900px"></iframe> -->
    <div class="header-container">
      <div class="header flex-between">
        <a href="//100.canpoint.net/#/index" class="logo-box column">
          <img src="../../assets/images/login/logo1.2.png" class="login-logo" alt="" />
        </a>
        <div class="login-nav clearfix">
          <ul>
            <li>
              <a href="//www.canpoint.org.cn/" target="_blank">全品文教</a>
            </li>
            <li>
              <a href="https://www.canpoint.org.cn/about-us/about-us/" target="_blank">关于全品</a>
            </li>
            <li>
              <a href="//100.canpoint.net/admin/#/login" target="_blank"
                >管理后台</a
              >
            </li>
            <li>
              <el-popover
                placement="top"
                width="170"
                v-model="codeVisible"
                trigger="hover"
              >
                <img
                  src="../../assets/images/login/minapp_code.jpg"
                  class="login_code_img"
                />
                <a href="javascript:;" slot="reference">小程序</a>
              </el-popover>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="login-box">
      <div class="login flex-row-end">
        <div class="machine-box">
          <img
            src="../../assets/images/login/m.png"
            class="animation-machine"
            alt=""
          />
        </div>
        <div class="form-box column">
          <img
            src="../../assets/images/login/login_1.png"
            class="login-code"
            @click="onAdminStatus"
            v-if="isAdmin"
          />
          <img
            src="../../assets/images/login/login_2.png"
            class="login-code"
            @click="onAdminStatus"
            v-else
          />
          <div v-if="isAdmin" class="account-box">
            <div class="form-item flex-row-start">
              <div class="item-label">帐号：</div>
              <input
                v-model="form.guid"
                class="input-text"
                placeholder="请填写帐号"
              />
            </div>
            <img
              src="../../assets/images/login/line.png"
              class="login-line"
              alt=""
            />
            <div class="form-item flex-row-start">
              <div class="item-label">密码：</div>
              <input
                type="password"
                v-model="form.password"
                class="input-text"
                placeholder="请填写密码"
              />
            </div>
            <img
              src="../../assets/images/login/line.png"
              class="login-line"
              alt=""
            />
            <div class="form-button" @click="submitForm()">
              登 入
            </div>
          </div>
          <div class="column" v-else>
            <img src="../../assets/images/login/login_0826.png" class="qrcode" alt="">
            <p class="login-admin-msg" >帐号权限及课程问题请咨询微信客服</p>
          </div>
        </div>
      </div>
    </div>
    <div class="user-type-box">
      <div class="type-title">帐号分类</div>
      <div class="type-list flex-between">
        <div class="login-item column" @click="onSelectRole(0)">
          <img src="../../assets/images/login/t.png" class="type-img" alt="" />
          <div class="type-name">教师号</div>
          <div class="introduction">
            给教师提供备课资源和便捷的班级管理能力，智能组卷、自动阅卷、学情报表，为教师真真正正地减负。
          </div>
        </div>
        <div class="login-item column" @click="onSelectRole(1)">
          <img src="../../assets/images/login/s.png" class="type-img" alt="" />
          <div class="type-name">学生号</div>
          <div class="introduction">
            为学生提供知识点微课、智慧学内容、作业分析、学情报告、错题管理等辅学功能，为学生实实在在地导航。
          </div>
        </div>
        <div class="login-item column" @click="onSelectRole(2)">
          <img src="../../assets/images/login/p.png" class="type-img" alt="" />
          <div class="type-name">家长号</div>
          <div class="introduction">
            为家长同步孩子的班级作业提醒，消息阅读状态，作业完成情况、教师点评内容，综合学情分析，帮家长轻轻松松地伴学。
          </div>
        </div>
      </div>
    </div>

    <div class="login-footer">
      <div class="footer-info-box column">
        <div>
          Copyright © 2010-{{ year }}北京全品文教科技股份有限公司 All rights
          reserved. 京ICP备 15050178号-2 京ICP证161058 京网文[2017] 2347-233号
        </div>
        <div class="pt5">
          适龄提示：适合7岁以上使用
          <span class="ml10" @click="login">网络游戏未成年人家长监护工程</span>
        </div>
      </div>
      <div style="width:300px;margin:0 auto; padding:20px 0;">
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802029792"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
          ><img src="../../assets/record_icon.png" style="float:left;" />
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;font-size:12px"
          >
            京公网安备 11010802029792号
          </p></a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "../../assets/css/dialog.css";
export default {
  data: function() {
    return {
      isLoading: false,
      activeIndex: 0,
      tabList: [
        { title: "教师号", id: 3 },
        { title: "学生号", id: 1 },
        { title: "家长号", id: 2 },
      ],
      form: {
        guid: "",
        password: "",
        types: 0,
      },
      fullscreenLoading: false,
      codeVisible: false,
      year: new Date().getFullYear(),
      isAdmin: true
    };
  },
  created() {
    this.guid = this.$route.query.guid;
    if (this.guid) {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.authCheck();
    } else {
      this.isLoading = true;
    }
  },
  methods: {
    onSelectRole() {
      // this.activeIndex = i;
      // if (this.activeIndex === 0) {
      //   this.form = {
      //     guid: "6414348827",
      //     password: "123456",
      //   };
      // } else if (this.activeIndex === 1) {
      //   this.form = {
      //     guid: "6443052138",
      //     password: "123456",
      //   };
      // } else {
      //   this.form = {
      //     guid: "6416482451",
      //     password: "123456",
      //   };
      // }
    },
    ...mapActions(["USER_SIGNIN"]),
    login() {
      window.location =
        "http://182.92.128.136/user/login.aspx?user=test&pwd=test";
    },
    authCheck() {
      this.postRequest("/wenjiaoopne/kc/auth/authCheck", { guid: this.guid })
        .then((result) => {
          this.loading.close();
          if (result.error_code > 0) {
            this.$message.error(result.message);
            this.isLoading = true;
            return false;
          }
          this.USER_SIGNIN(result.data.user);
          if (result.data.user.role === "patriarch") {
            this.$router.push("/patriarch/inform");
          } else {
            this.$router.push("/list");
          }
        })
        .catch(() => {
          this.loading.close();
        });
    },
    submitForm() {
      if (this.form.guid.trim() === "") {
        this.$message.error("请填写帐号");
        return false;
      }
      if (this.form.password.trim() === "") {
        this.$message.error("请填写正确密码");
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.postRequest("/wenjiaoopne/kc/auth/index", this.form)
        .then((result) => {
          loading.close();
          if (result.error_code > 0) {
            this.$message.error(result.message);
            return false;
          }
          this.USER_SIGNIN(result.data.user);
          if (result.data.user.role === "patriarch") {
            this.$router.push("/patriarch/inform");
          } else {
            this.$router.push("/list");
          }
        })
        .catch(() => {
          loading.close();
        });
    },
    onAdminStatus(){
      this.isAdmin = !this.isAdmin
    }
  },
};
</script>
<style scoped>
.login-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.login-container .header-container {
  width: 100%;
  height: 150px;
  background-color: #fff;
}
.login-container .header {
  width: 1195px;
  margin: 0 auto;
}
.account-box{
  padding-top: 10px;
}
.login-box .qrcode{
  width: 155px;
  height: 155px;
}
.login-box .login-admin-msg{
  padding-top: 10px;
  color: #9490A1;
}
.login-container .logo-box {
  position: relative;
  height: 150px;
}

.login-container .login-logo {
  position: absolute;
  height: 90px;
  top: 22px;
  left: 0;
}
.login-container .login-nav li {
  float: left;
  width: 120px;
  text-align: center;
  font-size: 18px;
  border-right: 1px solid #666;
  cursor: pointer;
}
.login-container .login-nav li a {
  color: #2d2e2f;
}
.login-container .login-nav li:hover a {
  color: #40b8ee;
}
.login-container .login-nav li:last-child {
  border: none;
}

.login-container .login-box {
  width: 100%;
  height: 345px;
  background: url("../../assets/images/login/bg.jpg");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.login-container .login {
  position: relative;
  width: 1195px;
  margin: 0 auto;
  height: 345px;
  background: url("../../assets/images/login/pfw2.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.login-container .machine-box {
  position: absolute;
  top: 55px;
  left: 220px;
  width: 223px;
  height: 188px;
}
.animation-machine {
  animation: a_machine 3.5s ease-in-out infinite;
}

@keyframes a_machine {
  0% {
    transform: translate3d(0px, 10px, 5px);
  }
  50% {
    transform: translate3d(-10px, 0px, -10px);
  }
  100% {
    transform: translate3d(0px, 10px, 5px);
  }
}

.login-container .form-box {
  position: relative;
  width: 385px;
  height: 280px;
  border-radius: 10px;
  margin-right: 100px;
  background-color: #fff;
}
.login-container .login-code {
  position: absolute;
  top: 0;
  right: -2px;
  width: 65px;
  height: 56px;
  cursor: pointer;
}
.login-container .form-item {
  /* padding: 12px 0; */
  padding-top: 10px;
  color: #a2c1ce;
}
.login-container .item-label {
  font-size: 18px;
}
.login-container .input-text {
  width: 240px;
  padding: 10px;
  border: none;
}

.login-container .form-button {
  width: 315px;
  height: 50px;
  line-height: 50px;
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  background-color: #ff9405;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}
.login-container .user-type-box {
  width: 1095px;
  margin: 0 auto;
}
.login-container .type-title {
  height: 85px;
  line-height: 85px;
  font-size: 18px;
}
.login-container .type-img {
  width: 110px;
  height: 110px;
}
.login-container .login-item {
  width: 30%;
  height: 320px;
  border-radius: 5px;
  background-color: #ecf9ff;
  cursor: pointer;
}
.login-container .login-item:hover {
  box-shadow: 0px 1px 10px #3d94a3;
}
.login-container .type-name {
  color: #2d2e2f;
  margin: 20px 0;
  font-size: 20px;
}
.login-container .introduction {
  width: 78%;
  color: #8ea7b1;
  font-size: 15px;
}
.login-container .login-footer {
  margin-top: 45px;
}
.login-container .footer-info-box {
  width: 100%;
  height: 85px;
  background-color: #504a4e;
}
.login-container .footer-info-box {
  margin: 0 auto;
  color: #fff;
  font-size: 14px;
}
</style>
